import { ElementType, RelativeTransformData, WhiteboardElement, WhiteboardOptions } from "ng-whiteboard";
import * as pako from 'pako';
import { DrawingProperties, FontOption, LineStyle, LineWidthOption } from "../models/whiteboard";

export const INITIAL_TRANSFORM_DATA: RelativeTransformData = {selectionBounds: undefined, elementsTranslation: {x:0,y:0}, zoomRelative: 1,x:0,y:0}

export class WhiteboardHelper {
    static isInitialTransformData(data: RelativeTransformData): boolean {
        return data.selectionBounds === undefined && data.zoomRelative === INITIAL_TRANSFORM_DATA.zoomRelative && 
                data.x === INITIAL_TRANSFORM_DATA.x && data.y === INITIAL_TRANSFORM_DATA.y  && 
                data.elementsTranslation?.x === INITIAL_TRANSFORM_DATA.elementsTranslation?.x && data.elementsTranslation?.y === INITIAL_TRANSFORM_DATA.elementsTranslation?.y;
    }

    
    static sendWhiteboardEnabled(){

    }
    static sendWhiteboardElements(){
        
    }
    
    static zipWhiteboardElements(elements: WhiteboardElement[]): string {
        const compressed = pako.gzip(JSON.stringify(elements));
        const base64 = btoa(String.fromCharCode(...compressed));
        return base64;
    }
    static unzipWhiteboardElements(data: string): WhiteboardElement[] {
        const binaryString = atob(data);
        const bytes = new Uint8Array(binaryString.length);
        for (let i = 0; i < binaryString.length; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }
        const decompressed = pako.ungzip(bytes, { to: 'string' });
        return JSON.parse(decompressed) as WhiteboardElement[];
    }

    static createTextElement(start: any, text: string, options: WhiteboardOptions): WhiteboardElement {
        const textElement: WhiteboardElement = {
            id: this.generateUniqueId(),
            type: ElementType.Text,
            x: start.offsetX,
            y: start.offsetY,
            text: text,
            rotation: 0,
            opacity: 100,
            // ,
            style: {
                color: options.strokeColor,
                fill: options.strokeColor,
                strokeColor: options.fill,
            },
            isDeleting: false,
            scaleX: 1,
            scaleY: 1,
        }
        return textElement
    }   
    static createRectangleElement(start:any, end: any, options: WhiteboardOptions): WhiteboardElement {
        const rectElement: WhiteboardElement = {
            id: this.generateUniqueId(),
            type: ElementType.Rectangle,
            x: start.offsetX,
            y: start.offsetY,
            width: end.offsetX - start.offsetX,
            height: end.offsetY - start.offsetY,
            rotation: 0,
            opacity: 100,
            style: {
                fill: options.fill,
                strokeColor: options.strokeColor,
            },
            isDeleting: false,
            rx: 0
        };
        return rectElement;
    }   

    private static generateUniqueId(): string {
        return 'element-' + Math.random().toString(36).substr(2, 9);
    }


    static readonly drawingPropertiesDefaults: DrawingProperties = {
        strokeColor: '#000000',
        strokeWidth: 5,
        lineStyle: 'solid',
        fontFamily: 'sans-serif',
        fontSize: 24,
        fontStyle: 'normal',
        fontWeight: 'normal'
    };
    static readonly  lineWidthOptionsDefault: LineWidthOption[] = [
        { value: 1, label: '1px' },
        { value: 2, label: '2px' },
        { value: 3, label: '3px' },
        { value: 5, label: '5px' },
        { value: 8, label: '8px' },
        { value: 12, label: '12px' },
        { value: 16, label: '16px' },
        { value: 24, label: '24px' }
    ];

    static readonly fontOptionsDefault: FontOption[] = [
        { value: 'Arial', label: 'Arial' },
        { value: 'Times New Roman', label: 'Times New Roman' },
        { value: 'Courier New', label: 'Courier New' },
        { value: 'Georgia', label: 'Georgia' },
        { value: 'Verdana', label: 'Verdana' },
        { value: 'sans-serif', label: 'Sans serif' },
        { value: 'Comic Sans MS', label: 'Comic Sans MS' },
        { value: 'Trebuchet MS', label: 'Trebuchet MS' },
        { value: 'Arial Black', label: 'Arial Black' }
    ];

    static readonly fontSizeOptionsDefault = [10, 12, 14, 16, 18, 20, 24, 28, 32, 36, 48, 64];

    static getStrokeDashArray(style: LineStyle): string {
        switch (style) {
        case 'dashed':
            return '10 5';
        case 'dotted':
            return '2 3';
        default:
            return '';
        }
    }

    static getLineStyleFromDashArray(dasharray: string, lineWidth: number): LineStyle {
        const s = dasharray.split(' ').map(s => parseFloat(s));
        if (dasharray === `${lineWidth * 3} ${lineWidth * 2}`) {
            return 'dashed';
        } else if (dasharray === `${lineWidth * 1.2} ${lineWidth * 1.5}`) {
            return 'dotted';
        } else {
            return 'solid';
        }
    }


    static lineStyleToDashArray(lineStyle: LineStyle, lineWidth: number): string {
        switch (lineStyle) {
            case 'dashed':
                return `${lineWidth * 3} ${lineWidth * 2}`;
            case 'dotted':
                return `${lineWidth * 1.2} ${lineWidth * 1.5}`;
            default:
                return '';
        }
    }
}